export const GLOBAL_STATE_ACTION_TYPES = {
  SET_CURRENT_REMIND_BAR_SHOW: "globalState/SET_CURRENT_REMIND_BAR_SHOW",
  SET_CURRENT_BILLING_BAR_SHOW: "globalState/SET_CURRENT_BILLING_BAR_SHOW",
  SET_DISCORD_AGENT_BINDING_BAR_SHOW:
    "globalState/SET_DISCORD_AGENT_BINDING_BAR_SHOW",
  SET_ADVANCED_SORTING: "globalState/SET_ADVANCED_SORTING",
};
